import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  markAllNotificationsRead,
  markNotificationsRead,
  useDigestLiveUpdate,
} from '../../entities/notification';

export const useNotificationDigest = () => {
  const client = useQueryClient();
  const digest = useDigestLiveUpdate();
  const [showOwn, setShowOwn] = useState(false);

  const refresh = () => client.invalidateQueries({ queryKey: ['notifications'] });

  const markRead = useMutation({ mutationFn: markNotificationsRead, onSuccess: refresh });
  const markAllRead = useMutation({ mutationFn: markAllNotificationsRead, onSuccess: refresh });

  return { digest, showOwn, setShowOwn, markRead, markAllRead };
};

export type TNotificationDigestState = ReturnType<typeof useNotificationDigest>;
